module.exports = __webpack_public_path__ + "img/widescreen_on.a6ffd8f3.png";